import { render, staticRenderFns } from "./base-history.vue?vue&type=template&id=76c9c2aa&"
import script from "./base-history.vue?vue&type=script&lang=ts&"
export * from "./base-history.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports